import { useCallback, useEffect, useState } from "react";
import { Busy } from "../../components/Busy";
import { FlightDetailsView } from "../../components/matches/FlightDetailsView";
import { MatchDetails, MatchSetupConfig } from "../../models/match";
import { MatchCard } from "../../components/matches/MatchCard";
import { usePublicStore } from "../../store/publicStore";
import { ArrowLeft } from "lucide-react";

const Fixtures = () => {
  const {
    currentSeason,
    getCurrentSeason,
    isBusy: busyGettingSeason,
    matchSetups: allMatchSetups,
    getMatchSetups,
    allTeams: teams,
    getAllGroupedTeams,
    allPlayers: players,
    isBusy,
  } = usePublicStore();

  const [selectedMatch, setSelectedMatch] = useState<MatchDetails | null>(null);
  const [selectedMatchSetup, setSelectedMatchSetup] =
    useState<MatchSetupConfig | null>(null);
  useEffect(() => {
    getMatchSetups();
  }, [getMatchSetups]);

  useEffect(() => {
    getCurrentSeason();
  }, [getCurrentSeason]);

  useEffect(() => {
    getAllGroupedTeams();
  }, [getAllGroupedTeams]);

  const handleViewFlights = useCallback(
    (match: MatchDetails, setupConfig: MatchSetupConfig) => {
      setSelectedMatch(match);
      setSelectedMatchSetup(setupConfig);
    },
    []
  );

  const getCourseDetails = (match: MatchDetails) => {
    if (!currentSeason) return null;
    if (!currentSeason.courseConfigs) return null;

    const course = currentSeason.courseConfigs.find(
      (c) => c.courseName === match.location
    );

    return course ?? null;
  };

  return (
    <div className="py-2 pb-6">
      <div className="">
        <div className="flex items-center mb-4 sm:mb-6">
          {selectedMatch && (
            <button
              onClick={() => setSelectedMatch(null)}
              className="mr-2 sm:mr-4 p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
            >
              <ArrowLeft className="h-5 w-5 sm:h-6 sm:w-6 text-gray-600 dark:text-gray-300" />
            </button>
          )}
          <h1 className="text-2xl font-semibold text-white">
            Fixtures
          </h1>
        </div>
        <div className="">
          {selectedMatch ? (
            <FlightDetailsView
              setupConfig={selectedMatchSetup!}
              players={players}
              teams={teams}
            />
          ) : (
            <>
              {/* Fixtures List */}
              <div className="space-y-4">
                {currentSeason?.seasonMatches &&
                  currentSeason?.seasonMatches.sort((a,b) => {
                    return a.date > b.date ? 1 : -1;
                  }).map((match) => {
                    if (!allMatchSetups) return null;
                    if (!allMatchSetups.find((m) => m.matchId === match.id))
                      return null;
                    return (
                      <MatchCard
                        key={match.id}
                        match={match}
                        setupConfig={
                          allMatchSetups.find((m) => m.matchId === match.id)!
                        }
                        onViewFlights={handleViewFlights}
                        courseConfig={getCourseDetails(match)}
                      />
                    );
                  })}
              </div>
            </>
          )}
        </div>
      </div>
      {(isBusy || busyGettingSeason) && <Busy busyMessage={""} />}
    </div>
  );
};

export default Fixtures;
